import { getBrowserInfo, getSystemInfo } from "./util"
let _environment = ""
let _regionServerSupportedMap: Record<string, string>
let REGION = ""

export const env = {
  platform: "web",
  sysVersion: getBrowserInfo(),
  modelType: getSystemInfo(),
  softVersion: "",
  appVersionCode: "",
  screenWidth: document?.body?.clientWidth,
  screenHeight: document?.body?.clientHeight,
  intranetIp: "",
  appPackageName: "",
  // getIDEEnv: () => IDEEnv.get(),
}

export const envFn = {
  setEnv: (env: string) => {
    if (env) _environment = env
  },
  getEnv: () => {
    return _environment
  },
}

export const region = {
  init(region: string, regionServerSupportedMap: Record<string, string>) {
    const __region = sessionStorage.getItem("__region")
    if (__region) {
      REGION = __region
    } else if (region) {
      REGION = region
      sessionStorage.setItem("__region", region)
    } else {
      console.log(`init region fail: ${__region}, ${region}`)
    }
    if (regionServerSupportedMap) {
      _regionServerSupportedMap = regionServerSupportedMap
    } else {
      console.log(
        `init region map fail: ${JSON.stringify(_regionServerSupportedMap)}`
      )
    }
  },
  set(region: string) {
    if (REGION === region) return false
    if (_regionServerSupportedMap && !_regionServerSupportedMap[region]) {
      console.log(
        `set region fail: ${region} not found in ${JSON.stringify(
          _regionServerSupportedMap
        )}`
      )
      return false
    }
    REGION = region
    sessionStorage.setItem("__region", region)
    return true
  },
  get() {
    return REGION
  },
  getMap() {
    return _regionServerSupportedMap
  },
}
